import React from 'react';
import { Grid, Box, CircularProgress } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles(theme => ({
//   progress: {
//     color: theme.palette.background.paper
//   }
// }));

interface LoadingProps {
  data?: string;
}

export const Loading: React.FC<LoadingProps> = props => {
  // const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box alignSelf="center" mt={2}>
              <Grid container justify="center" alignContent="center">
                <CircularProgress color="primary" />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
